<template>
    <ThSpacer :size="data.spacing" />
</template>

<script setup lang="ts">
import type { ComponentSpacerFragment } from '@/graphql/api'

import ThSpacer from '@/components/ui/ThSpacer.vue'

defineProps<{
    data: ComponentSpacerFragment
}>()
</script>
